import { useGetApiV1ExamAuthorDropdown } from '@/shared/api/generated';

/**
 * Resolve o rótulo (nome) de um autor a partir do seu id.
 *
 * A API de detalhe da questão devolve apenas `personAuthorId`, sem o nome. Este
 * hook consulta o lookup completo de autores (`exam/author-dropdown`) para exibir
 * o nome do autor já selecionado ao editar. Só dispara quando há um id.
 *
 * @param authorId - Id do autor como string (`''` quando não há seleção).
 * @returns Nome do autor, ou `''` enquanto carrega / quando não encontrado.
 */
export function useAuthorName(authorId: string) {
  const { data } = useGetApiV1ExamAuthorDropdown(undefined, {
    query: { enabled: authorId !== '' },
  });

  return (data ?? []).find(option => String(option.key ?? '') === authorId)?.value ?? '';
}
